export const T_Configurator = {};
